import React, { useEffect, useState } from "react";
import { Route, Switch } from "react-router-dom";
import Register from "../components/registeration/register";
import AddNewAccount from "../components/registeration/newAccount";
import OverView from "../components/TransactionHistory/overView";
import TransactionDetails from "../components/TransactionHistory/transactionDetails";
import Transaction from "../components/TransactionHistory/transactionHistory";
import ContactsList from "../components/contacts/contactsList";
import Setting from "../components/setting/setting";
import SendBoa from "../components/transaction/sendBoa/sendBoa";
import Freezing from "../components/transaction/freezing/freezing";
import UnFreezing from "../components/transaction/unFreezing/unFreezing";
import TransactionSuccessful from "../components/transaction/sharedComponent/transactionSuccessful";
import NavBar from "../components/Bars/navBar";
import * as sdk from "boa-sdk-ts";
import SideBar from "../components/Bars/sideBar";
import AlertModal from "../components/AlertModal/alertModal";
import { connect, useDispatch } from "react-redux";
import { WalletMA } from "boa-sdk-ts";
import PendingTransactionOverview from "../components/TransactionHistory/PendingTransactionOverview";
import { ErrorCheckUtil } from "../utils/ErrorCheckUtil";
import { Redirect, useLocation } from "react-router";
import StoreData from "../components/transaction/storeData/storeData";
import { useTranslation } from "react-i18next";
import { getNetworksURL, loadNetworkStatus } from "../utils/WalletUtils";
import Toast from "../components/common/toast";
import { changeEndpoint } from "../actions/networkAction";

const { BOASodium } = require("boa-sodium-ts");

const App = (props) => {
  const { t } = useTranslation();
  const location = useLocation();
  const dispatch = useDispatch();
  const [app, setApp] = useState(false);
  const [isMenu, setIsMenu] = useState(false);
  const { alertMessage, alertMessage2, openAlertModal } = props;

  React.useEffect(() => {
    if (location.pathname === "/" || location.pathname === "/add-new-account") {
      setIsMenu(false);
    } else {
      setIsMenu(true);
    }
  }, [location]);

  useEffect(() => {
    props.i18n.changeLanguage(localStorage.getItem("i18nextLng"));
    try {
      if (!sdk.SodiumHelper.isAssigned())
        sdk.SodiumHelper.assign(new BOASodium());
      sdk.SodiumHelper.init().then(() => {
        const networkStatus = loadNetworkStatus();
        WalletMA.setDefaultEndpoint(
          getNetworksURL(networkStatus ? networkStatus : "COIN")
        );
        WalletMA.instance();
        networkStatus && dispatch(changeEndpoint(networkStatus));
        ErrorCheckUtil.init(dispatch, t);
        setApp(true);
      });
    } catch (e) {
      console.log("startError");
    }
  }, []);

  return (
    <>
      {app && (
        <div className="main-content">
          <div className="container-fluid">
            <NavBar />
            <div className="main-container">
              <div className="row">
                <div className="col-md-12">
                  <div className="Main">
                    {isMenu ? (
                      <div className="SideMenu">
                        <SideBar />
                      </div>
                    ) : null}
                    <Switch>
                      <Route exact path="/" component={Register} />
                      <Route
                        exact
                        path="/add-new-account"
                        component={AddNewAccount}
                      />

                      <Route exact path="/overview" component={OverView} />
                      <Route
                        path="/(overview/transactionDetail|transactions-history/details)"
                        component={TransactionDetails}
                      />
                      <Route
                        path="/overview/pendingTransactionDetails"
                        component={PendingTransactionOverview}
                      />
                      <Route
                        exact
                        path="/transactions-history"
                        component={Transaction}
                      />
                      <Route
                        path="/transactions-history/:page"
                        component={Transaction}
                      />
                      <Route path="/send-boa" component={SendBoa} />
                      <Route path="/create-validator" component={Freezing} />
                      <Route path="/unfreezing" component={UnFreezing} />
                      <Route path="/store-data" component={StoreData} />
                      <Route path="/contact-list" component={ContactsList} />
                      <Route path="/settings" component={Setting} />
                      <Route
                        path="/success"
                        component={TransactionSuccessful}
                      />
                    </Switch>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Something went wrong or error alert message modal component */}
          {openAlertModal && (
            <AlertModal
              alertMessage={alertMessage}
              alertMessage2={alertMessage2}
              openAlertModal={openAlertModal}
            />
          )}
          <Toast />
        </div>
      )}
    </>
  );
};
const mapStateToProps = (state) => {
  return {
    alertMessage: state.alert.message,
    alertMessage2: state.alert.message2,
    openAlertModal: state.alert.openAlertModal,
  };
};
export default connect(mapStateToProps)(App);
